import { SystemField } from "./system-field";

export class ReportSaleDetail extends SystemField{
     
     sale_date?:string;
     product_id?:string;
     category_id?:string;
     total_qty?:number;
     total_amount?:number;
     total_discount?:number;
     unit_price?:number;
     sale_time?:string;
}
